"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "enemonzo": {
    "e678a651": [{
      "hkey": "8fabbf89",
      "slug": "tartinis-colza",
      "name": "Tartinis-Colza",
      "primary": true,
      "skipSearch": false
    }],
    "colza": [{
      "hkey": "8fabbf89",
      "slug": "tartinis-colza",
      "name": "Tartinis-Colza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "enemonzo"
    }],
    "3d9da61e": [{
      "hkey": "1e499557",
      "slug": "enemonzo",
      "name": "Enemonzo",
      "primary": true,
      "skipSearch": false
    }],
    "esemon-di-sotto": [{
      "hkey": "1e499557",
      "slug": "enemonzo",
      "name": "Enemonzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "644c1b8e": [{
      "hkey": "5c7dbfa9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "quinis": [{
      "hkey": "5c7dbfa9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a348061f": [{
      "hkey": "8fabbf89",
      "slug": "tartinis-colza",
      "name": "Tartinis-Colza",
      "primary": true,
      "skipSearch": false
    }],
    "tartinis": [{
      "hkey": "8fabbf89",
      "slug": "tartinis-colza",
      "name": "Tartinis-Colza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8f0cf1aa": [{
      "hkey": "5c7dbfa9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centro-quinis": [{
      "hkey": "5c7dbfa9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;